export enum MixpanelExtraParamsKeys {
  SOURCE = 'src',
}

export const DeductionSourceParamValues: string[] = ['invoice'];

export interface MixpanelExtraParams {
  [MixpanelExtraParamsKeys.SOURCE]?: string;
}

export enum Modules {
  DEDUCTIONS = 'deductions',
}
